
      import API from "!../../../../doc-site/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../doc-site/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../doc-site/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../doc-site/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../doc-site/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../doc-site/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../doc-site/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../doc-site/node_modules/postcss-loader/dist/cjs.js!./IdentityCard.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../doc-site/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../doc-site/node_modules/postcss-loader/dist/cjs.js!./IdentityCard.css";
       export default content && content.locals ? content.locals : undefined;
